import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";

export const fetchAllAssignedTasks = createAsyncThunk(
  'assignedTasks/fetchAll',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/projectAssignedTask/getallassigned`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAssignedTasksByPerson = createAsyncThunk(
  'assignedTasks/fetchByPerson',
  async (person, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/projectAssignedTask/assigned-task/${person}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createAssignedTask = createAsyncThunk(
  'assignedTasks/create',
  async (taskData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/projectAssignedTask/assigned-task`, taskData);
      return response.data.assignedTask;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateAssignedTask = createAsyncThunk(
  'assignedTasks/update',
  async ({ id, updatedData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`/projectAssignedTask}/assigned-task/${id}`, updatedData);
      return response.data.task;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteAssignedTask = createAsyncThunk(
  'assignedTasks/delete',
  async (id, thunkAPI) => {
    try {
      await axiosInstance.delete(`/projectAssignedTask/assigned-task/${id}`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const assignedTaskSlice = createSlice({
  name: 'assignedTasks',
  initialState: {
    tasks: [],
    assignedTasks:[],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchAllAssignedTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllAssignedTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = action.payload;
      })
      .addCase(fetchAllAssignedTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchAssignedTasksByPerson.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssignedTasksByPerson.fulfilled, (state, action) => {
        state.loading = false;
        state.assignedTasks = action.payload;
      })
      .addCase(fetchAssignedTasksByPerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createAssignedTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAssignedTask.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks.push(action.payload);
      })
      .addCase(createAssignedTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateAssignedTask.fulfilled, (state, action) => {
        state.tasks = state.tasks.map((task) =>
          task._id === action.payload._id ? action.payload : task
        );
      })

      .addCase(deleteAssignedTask.fulfilled, (state, action) => {
        state.tasks = state.tasks.filter((task) => task._id !== action.payload);
      });
  }
});

export default assignedTaskSlice.reducer;
